import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function SolidUniversityIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M21 9c.6 0 1-.4 1-1V5c0-.4-.3-.8-.7-.9l-9-3c-.2-.1-.4-.1-.6 0l-9 3c-.4.1-.7.5-.7.9v3c0 .6.4 1 1 1h1v7.2c-1.2.4-2 1.5-2 2.8v2c0 .6.4 1 1 1h18c.6 0 1-.4 1-1v-2c0-1.3-.8-2.4-2-2.8V9h1ZM8 16H6V9h2v7Zm6 0h-4V9h4v7Zm4 0h-2V9h2v7Z"/>
  </SvgIcon>
}

export default SolidUniversityIcon
